import { m } from 'framer-motion';

export function ConfettiBurst() {
  const colors = ['#FFC93C', '#FF4D6A', '#39FF88', '#FF9F1C', '#4ecdc4', '#f38181'];

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 1, overflow: 'hidden' }}>
      {Array.from({ length: 50 }).map((_, i) => (
        <ConfettiPiece
          key={i}
          color={colors[i % colors.length]}
          delay={Math.random() * 0.5}
          duration={2 + Math.random() * 2}
          x={Math.random() * 100}
        />
      ))}
    </div>
  );
}

export function ConfettiPiece({ color, delay, duration, x }: { color: string; delay: number; duration: number; x: number }) {
  return (
    <m.div
      initial={{ y: '-10vh', opacity: 0, rotate: 0 }}
      animate={{ y: '110vh', opacity: [1, 1, 0], rotate: 720 }}
      transition={{ delay, duration, ease: 'linear' }}
      style={{
        position: 'absolute',
        left: `${x}%`,
        width: '12px',
        height: '12px',
        background: color,
        borderRadius: Math.random() > 0.5 ? '50%' : '2px',
        transform: `rotate(${Math.random() * 360}deg)`,
      }}
    />
  );
}